import { isString } from 'lodash-es'
import { InputHTMLAttributes, useState } from 'react'

import { DEFAULT_REQUIRED_FIELD } from '@/components/entities/requests/model/constants'

type Props = {
  value: InputHTMLAttributes<HTMLTextAreaElement>['value']
  minLength?: number
  maxLengthMessageFrom?: number
}

export const useMinMaxLengthMessage = ({
  value,
  minLength,
  maxLengthMessageFrom
}: Props) => {
  const [inputFocused, setInputFocused] = useState(true)

  const valueLength = isString(value) ? value.length : 0

  const isValueLengthUnreached = valueLength < (minLength ?? 0)

  const isMinLengthInvalid = isValueLengthUnreached && !inputFocused

  const showMinLengthMessageValid =
    (minLength ?? 0) > DEFAULT_REQUIRED_FIELD && isValueLengthUnreached

  const showMaxLengthMessageValid = valueLength >= (maxLengthMessageFrom ?? 0)

  return {
    valueLength,
    isMinLengthInvalid,
    showMinLengthMessageValid,
    showMaxLengthMessageValid,
    setInputFocused
  }
}
